




































































































































































import { Component, Prop } from "vue-property-decorator";
import axios from "axios";
import HacoBase from "../HacoBase";
import {
  inputItems,
  resultLabels,
  expectedLabels,
  labels
} from "../itemDefinitons";

const colorIds = {
  IRO: 23,
  TANTO: 24,
  BIOTOPE: 26
};

interface InputItems {
  name: string;
  label: string;
  jsonKey: string;
  optionName: string;
  selections: object[] | null;
  value: number;
  visible: boolean;
}

@Component
export default class ShowInputItems extends HacoBase {
  @Prop({ type: String, default: "hacoplay" })
  calcType!: string;

  $debugServer!: string;
  inputItems: InputItems[] = [];
  resultData: any = {};
  resultLabels: any = {};
  calculated = false;
  hasPreviousData = false;
  textLink = "";
  chip = "";
  locale = "en";
  labels: any = {
    ja: {},
    en: {}
  };

  mounted(): void {
    this.$set(this, "inputItems", inputItems);
    this.$set(this, "resultLabels", resultLabels);
    this.$set(this, "labels", labels);
    this.locale = this.$i18n.locale;
    const localStorage: Storage = window.localStorage;
    this.hasPreviousData = localStorage.getItem(
      "preset" + (this.calcType === "paperBug" ? "PaperBug" : "")
    )
      ? true
      : false;
    const url = this.$debugServer + "/api/v1_inner/estimateParamsDb";
    const params: object = this.setAxiosParams(url, "get");
    // データ取ってくる
    axios(params)
      .then((response: any): void => {
        const data: any = response.data;
        if (this.calcType === "paperBug") {
          if (data["paperColor"]) {
            /// カラー変更
            data["paperColorIro"] = this.filterColorObject(
              data["paperColor"],
              colorIds.IRO
            );
            data["paperColorTanto"] = this.filterColorObject(
              data["paperColor"],
              colorIds.TANTO
            );
            data["paperColorBiotope"] = this.filterColorObject(
              data["paperColor"],
              colorIds.BIOTOPE
            );
          }
          if (data["boxType"]) {
            data["boxType"] = this.getPaperBugObject(data["boxType"]);
          }
          if (data["paperType"]) {
            data["paperType"] = this.getPaperBugObject(data["paperType"]);
          }
        } else {
          if (data["boxType"]) {
            data["boxType"] = this.getPaperBugObject(data["boxType"], 0);
          }
          if (data["paperType"]) {
            data["paperType"] = this.getPaperBugObject(data["paperType"], 0);
          }
        }
        let item: any;
        let i = 0;
        for (item of this.inputItems) {
          if (
            data[item.jsonKey] &&
            (!item.calcType || item.calcType === this.calcType)
          ) {
            this.$set(this.inputItems[i], "selections", data[item.jsonKey]);
          }
          i += 1 | 0;
        }
      })
      .catch((error: any): void => {
        console.log("[error]", error.response);
        this.toLoginPage(error);
      });
  }

  filterColorObject(items: Record<string, any>, colorId: number): any[] {
    return Object.keys(items)
      .filter(colorKey => Number(items[colorKey].paper_type_id) === colorId)
      .map(mapKey => {
        items[mapKey].id = items[mapKey].color_id;
        return items[mapKey];
      });
  }

  getPaperBugObject(items: Record<string, any>, isOne = 1): any[] {
    return Object.keys(items)
      .filter(key => Number(items[key].is_paper_bug) === isOne)
      .map(mapKey => items[mapKey]);
  }

  /** 編集内容を送信 */
  onSubmit(): void {
    let item: InputItems;
    const editData = new URLSearchParams();
    let isValid = true;
    const localStorage: Storage = window.localStorage;
    localStorage.setItem(
      "preset" + (this.calcType === "paperBug" ? "PaperBug" : ""),
      JSON.stringify(this.inputItems)
    );
    for (item of this.inputItems) {
      if (typeof item.value !== "number") {
        isValid = false;
        break;
      }
      editData.append(item.name, item.value.toString());
    }
    if (isValid === false) {
      alert("数値以外の入力があります。");
      return;
    }
    const url =
      this.$debugServer +
      "/api/v1_inner/" +
      (this.calcType === "paperBug" ? "pb" : "");
    const params: object = this.setAxiosParams(
      url,
      "post",
      editData,
      "application/x-www-form-urlencoded;charset=UTF-8"
    );
    // データ取ってくる
    axios(params)
      .then((response: any): void => {
        this.showResult(response.data);
      })
      .catch((error: any): void => {
        console.log("[Posting Error]", error);
        Object.keys(error).forEach((k: string) => {
          console.log(k, error[k]);
        });
        this.toLoginPage(error);
      });
  }

  /** 前回の入力内容を復元する */
  restoreValues(): void {
    const localStorage: Storage = window.localStorage;
    const preset = JSON.parse(
      localStorage.getItem(
        "preset" + (this.calcType === "paperBug" ? "PaperBug" : "")
      ) || ""
    );

    let i = 0;
    for (const item of preset) {
      this.inputItems[i].value = item.value;
      i += 1 | 0;
    }
  }

  /** 結果表出す */
  showResult(data: any): void {
    this.resultData = {
      Common: {},
      Results: {},
      specScenarioResult: {}
    };

    /** 二度以上の送信の際にspecScenarioResultを復活させとく  */
    if (this.resultLabels.Results.specScenarioResult === undefined) {
      this.$set(
        this.resultLabels.Results,
        "specScenarioResult",
        this.resultLabels.specScenarioResult
      );
    }

    /** 二度以上の送信の際にotherCostを復活させとく  */
    if (this.resultLabels.Results.OtherResult.otherCost === undefined) {
      this.$set(
        this.resultLabels.Results.OtherResult,
        "otherCost",
        expectedLabels.otherCost
      );
    }

    /** 二度以上の送信の際にotherCostを復活させとく  */
    if (
      this.resultLabels.Results.scenarioOption.totalScenarioOptionCost ===
      undefined
    ) {
      this.$set(
        this.resultLabels.Results.scenarioOption,
        "totalScenarioOptionCost",
        expectedLabels.totalScenarioOptionCost
      );
    }

    /** 二度以上の送信の際にcustomCostを復活させとく  */
    if (this.resultLabels.Results.customResult.isMargin === undefined) {
      this.$set(
        this.resultLabels.Results.customResult,
        "isMargin",
        expectedLabels.isMargin
      );
    }
    /** 二度以上の送信の際にcustomCostを復活させとく  */
    if (this.resultLabels.Results.customResult.totalCost === undefined) {
      this.$set(
        this.resultLabels.Results.customResult,
        "totalCost",
        expectedLabels.customTotalCost
      );
    }

    Object.keys(this.resultLabels.Common).forEach((label: string): void => {
      this.resultData.Common[label] = this.checkIncorrectValue(data[label]);
    });

    /** 詳細 各シナリオ項目 */
    const specScenarioResult: any = {};

    Object.keys(data.Results).forEach((scenario: string): void => {
      const scenarioName = data.Results[scenario].scenario.scenarioName;
      this.resultData.Results[scenario] = {
        scenario: {
          scenarioName: scenarioName
        }
      };

      Object.keys(this.resultLabels.Results).forEach((key: string): void => {
        if (key === "specScenarioResult") {
          /** specScenarioResult を追加　ついでにシナリオ名も加えとく */
          specScenarioResult[scenario] = Object.assign(
            {
              scenarioName: scenarioName
            },
            data.Results[scenario].specScenarioResult
          );
        } else {
          const category: {} = this.resultLabels.Results[key];
          this.resultData.Results[scenario][key] = {};
          Object.keys(category).forEach((label: string): void => {
            try {
              this.resultData.Results[scenario][key][
                label
              ] = this.checkIncorrectValue(data.Results[scenario][key][label]);
            } catch (e) {
              this.resultData.Results[scenario][key][label] = " -";
            }
          });
        }
      });
      /** customCostを加える */
      if (data.Results[scenario].customResult) {
        if (data.Results[scenario].customResult.isMargin === 1) {
          /** マージンありの場合 */
          this.resultData.Results[
            scenario
          ].scenarioOption.customImargin = this.checkIncorrectValue(
            this.resultData.Results[scenario].customResult.totalCost
          );
        } else {
          /** マージンなしの場合 */
          this.resultData.Results[
            scenario
          ].totalResult.customEmargin = this.checkIncorrectValue(
            this.resultData.Results[scenario].customResult.totalCost
          );
        }
      }

      /** 配送料も本来共通なので例外的に個別表に加える */
      if (data.Results[scenario].totalResult) {
        this.resultData.Results[scenario]["totalResult"][
          "calcDeliveryCost"
        ] = this.checkIncorrectValue(data.calcDeliveryCost);
      }

      /** otherCostをscenarioOptionの最後尾に見た目上移動する */
      if (data.Results[scenario].scenarioOption) {
        this.resultData.Results[scenario]["scenarioOption"][
          "otherCost"
        ] = this.checkIncorrectValue(
          this.resultData.Results[scenario].OtherResult.otherCost
        );

        /** totalScenarioOptionCostをtotalResult内に見た目上移動する */
        if (data.Results[scenario].totalResult) {
          this.resultData.Results[scenario]["totalResult"][
            "totalScenarioOptionCost"
          ] = this.checkIncorrectValue(
            this.resultData.Results[scenario].scenarioOption
              .totalScenarioOptionCost
          );
        }
      }
      delete this.resultData.Results[scenario].OtherResult.otherCost;
      delete this.resultData.Results[scenario].scenarioOption
        .totalScenarioOptionCost;
      delete this.resultData.Results[scenario].customResult.isMargin;
      delete this.resultData.Results[scenario].customResult.totalCost;
    });

    /**　specScenarioResultを一旦Resultから外す  */
    delete this.resultLabels.Results.specScenarioResult;
    /** otherCostも一旦外す */
    delete this.resultLabels.Results.OtherResult.otherCost;
    /** totalScenarioOptionCostも一旦外す */
    delete this.resultLabels.Results.scenarioOption.totalScenarioOptionCost;
    /** customCostも一旦外す */
    delete this.resultLabels.Results.customResult.isMargin;
    delete this.resultLabels.Results.customResult.totalCost;

    /** specScenarioResultの見た目並び順を変える */
    const virtualSpecScenarioResult: any = {};
    Object.keys(data.Results).forEach((scenario: string): void => {
      virtualSpecScenarioResult[scenario] = {
        scenarioName: specScenarioResult[scenario].scenarioName
      };
      Object.keys(this.resultLabels.specScenarioResult).forEach(
        (label: string): void => {
          virtualSpecScenarioResult[scenario][label] = this.checkIncorrectValue(
            specScenarioResult[scenario][label]
          );
        }
      );
    });
    this.resultData.specScenarioResult = virtualSpecScenarioResult;
    this.calculated = true;
    setTimeout((): void => {
      const target: HTMLDivElement = document.getElementById(
        "result"
      ) as HTMLDivElement;
      const rectTop = target.getBoundingClientRect().top;
      const offsetTop = window.pageYOffset;
      const buffer = 50;
      const top = rectTop + offsetTop - buffer;
      window.scrollTo({
        top,
        behavior: "smooth"
      });
    }, 1);
  }

  checkIncorrectValue(val: any): any {
    let filterd: string;
    if (val === undefined) {
      filterd = "-";
    } else if (val === null || val === -1) {
      filterd = "error";
    } else {
      filterd =
        isNaN(val) === false ? new Intl.NumberFormat().format(val) : val;
    }
    return filterd;
  }

  /** ペーストした文字列からデータを生成 */
  parseSharedData(e: any): void {
    const matches: RegExpMatchArray = e.target.value.match(/\?(.+)/);
    const splited: string[] = matches[1].split("&");
    let item: string;
    const inputItems: InputItems[] = this.inputItems;
    let i = 0;
    for (const inputItem of inputItems) {
      for (item of splited) {
        const arr: string[] = item.split("=");
        if (inputItem.name === arr[0]) {
          inputItems[i].value = parseInt(arr[1], 10);
          break;
        }
      }
      i += 1 | 0;
    }
  }

  generateTextLink(): void {
    const inputItems: InputItems[] = this.inputItems;
    let item: InputItems;
    const linkTextArr: string[] = [];
    for (item of inputItems) {
      linkTextArr.push(item.name + "=" + item.value);
    }
    const linkText: string = linkTextArr.join("&");
    this.textLink = window.location.origin + "/api/v1_inner/?" + linkText;
    const sharedText: HTMLInputElement = document.getElementById(
      "sharedData"
    ) as HTMLInputElement;
    sharedText.select();
    document.execCommand("copy");
    this.showChip(this.labels[this.locale].copied);
  }

  showChip(message: string): void {
    this.chip = message;
    setTimeout((): void => {
      this.chip = "";
    }, 2000);
  }
}
